/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reason: NonNullable<unknown> }} Settings_Integrations_Zotero_Connect_ErrorInputs */

const en_settings_integrations_zotero_connect_error = /** @type {(inputs: Settings_Integrations_Zotero_Connect_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to connect Zotero: ${i?.reason}`)
};

const es_settings_integrations_zotero_connect_error = /** @type {(inputs: Settings_Integrations_Zotero_Connect_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo conectar Zotero: ${i?.reason}`)
};

/**
* | output |
* | --- |
* | "Failed to connect Zotero: {reason}" |
*
* @param {Settings_Integrations_Zotero_Connect_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_integrations_zotero_connect_error = /** @type {((inputs: Settings_Integrations_Zotero_Connect_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Integrations_Zotero_Connect_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_integrations_zotero_connect_error(inputs)
	return en_settings_integrations_zotero_connect_error(inputs)
});